<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<header class="header">
  <nav class="nav-container">
    <a routerLink="/landing" class="logo">
      <span class="logo-text">GLORIA</span>
    </a>

    <div class="nav-right">
      <!-- Language Selector -->
      <div #languageSelector class="language-selector" (click)="toggleLanguageDropdown($event)" tabindex="0">
        <span>{{ currentLang | uppercase }}</span>
        <span>▼</span>

        <ul class="language-dropdown" *ngIf="isLanguageDropdownOpen">
          <li *ngFor="let lang of languages" [class.active]="lang === currentLang" (click)="selectLanguage(lang, $event)" tabindex="0">
            {{ lang | uppercase }}
          </li>
        </ul>
      </div>

      <!-- Navigation Links -->
      <div class="nav-links" [class.mobile-open]="isMenuOpen">
        <ng-container *ngIf="sessionService.isLoggedIn; else guestLinks">
          <a routerLink="/home" class="nav-link" routerLinkActive="active">{{ "common.home" | translate }}</a>
          <a routerLink="/order-history" class="nav-link" routerLinkActive="active">{{
            "page.order.ordersHistory.title_short" | translate
          }}</a>
          <a routerLink="/cart" class="nav-link" routerLinkActive="active">
            <mat-icon>shopping_cart</mat-icon>
            <ng-container *ngIf="cartItemsCount$ | async as count">
              <span class="cart-badge" *ngIf="count > 0">{{ count }}</span>
            </ng-container>
          </a>
          <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events -->
          <a (click)="logout()" class="nav-link" tabindex="0">
            {{ "button.logout" | translate }}
          </a>
        </ng-container>

        <ng-template #guestLinks>
          <a routerLink="/login" class="nav-link" routerLinkActive="active">
            {{ "button.login" | translate }}
          </a>
          <a routerLink="/cart" class="nav-link" routerLinkActive="active">
            <mat-icon>shopping_cart</mat-icon>
            <ng-container *ngIf="cartItemsCount$ | async as count">
              <span class="cart-badge" *ngIf="count > 0">{{ count }}</span>
            </ng-container>
          </a>
        </ng-template>
      </div>

      <!-- Mobile Menu Toggle -->
      <button class="mobile-menu-toggle" (click)="toggleMenu($event)">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </nav>
</header>
